/**
 * /tenants/$slug/access-governance/credential-recovery — the tenant's credential recovery requests.
 */

import { createFileRoute } from "@tanstack/react-router";
import { credentialRecoveryKeys, fetchRecoveryRequests } from "@/features/credential-recovery/queries";
import { recoveryRequestsSearchSchema } from "@/features/credential-recovery/schemas";
import { RecoveryRequestsPage } from "@/features/credential-recovery/pages/recovery-requests-page";

export const Route = createFileRoute("/_authed/tenants/$slug/access-governance/credential-recovery/")({
  validateSearch: recoveryRequestsSearchSchema,
  loaderDeps: ({ search }) => ({ search }),
  loader: ({ context, deps }) =>
    context.queryClient.ensureQueryData({
      queryKey: credentialRecoveryKeys.requests(context.tenant.id, deps.search),
      queryFn: () => fetchRecoveryRequests(context.tenant.id, deps.search),
    }),
  component: RecoveryRequestsPage,
});
